export const ELEMENT_NODE = 1;
export const TEXT_NODE = 3;
export const DEFAULT_TITLE = 'Untitled';
export const PRIVATE_CHANNEL_NAME = 'Private';